import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { SiteActionCreators } from "../../store/actions/site";

import Loading from "../common/Loading";

import { AppActionCreators } from "../../store/actions/app";

const Sites = () => {
  const dispatch = useDispatch();
  const sites = useSelector((state) => state?.site?.sites);
  const navigate = useNavigate();
  const selectedSite = useSelector((state) => state?.site?.selectedSite);
  const integrationType = useSelector(
    (state) => state.auth.user.integrationType
  );

  // normally we can blacklist a reducer on redux config, but in this case
  // quickFilterStatus and selectedQuickFilter are all part of the app reducer
  // hence I just close the modal whenever Site component is rendered the first time.

  useEffect(() => {
    dispatch(AppActionCreators.setQuickFilterModal(false));
    dispatch(AppActionCreators.setSelectedQuickFilter({}));

    if (integrationType === 1) {
      navigate("/analytics/videos");
      return;
    }

    dispatch(SiteActionCreators.getSites()).then((res) => {
      if (!res.data?.length) {
        navigate(`/sites/add`);
        return;
      }
      const siteId =
        selectedSite === null || (!selectedSite?.id && !selectedSite?.virgulId)
          ? res?.data?.length > 1
            ? res?.data[1]?.id
            : res?.data[0]?.id
          : selectedSite?.id ?? selectedSite?.virgulId;
      dispatch(SiteActionCreators.getSite(siteId)).then(() => {
        navigate(`/sites/${siteId}`);
      });
    });
  }, [integrationType, dispatch, navigate, selectedSite]);

  if (integrationType === 1) {
    return null;
  }

  if (!sites) {
    return <Loading />;
  }

  return null;
};

export default Sites;
